import type { SVGProps } from 'react';
export const SvgLike = (props: SVGProps<SVGSVGElement>) => (
	<svg width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
		<path
			stroke="currentColor"
			d="M4.334 5.667h-2a.5.5 0 0 0-.5.5v5.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-5.5a.5.5 0 0 0-.5-.5ZM4.834 6.167l2.133-3.45c.308-.519.867-.85 1.467-.85H9.8c.614 0 1.117.503 1.117 1.116v2.684h.958a.7.7 0 0 1 .525.233l.1.117a.87.87 0 0 1 .15.883l-1.633 4.333c-.159.4-.542.667-.967.667H6.5c-.566 0-1.1-.267-1.45-.7l-.216-.267"
		/>
	</svg>
);
